import React from 'react'

const Certificates = () => {
  return (
    <div>Certificates</div>
  )
}

export default Certificates